// src/features/inventory/services/productGroups.js
import { apiClient } from '../../../services/api/client';

export const productGroupsAPI = {
  getProductGroups: () =>
    apiClient.get('/api/v1/inventory/product-groups/'),

  getProductGroupById: (productGroupId) =>
    apiClient.get(`/api/v1/inventory/product-groups/${productGroupId}`),

  createProductGroup: (data) =>
    apiClient.post('/api/v1/inventory/product-groups/', data),

  updateProductGroup: (productGroupId, data) =>
    apiClient.put(`/api/v1/inventory/product-groups/${productGroupId}`, data),

  deleteProductGroup: (productGroupId) =>
    apiClient.delete(`/api/v1/inventory/product-groups/${productGroupId}`),
};
